import React from 'react'

export default (props: any) => (
  <svg {...props} width="66" height="51" viewBox="0 0 66 51" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M66 0.599976H1V50.2H66V0.599976Z" fill="#0052B4" />
    <path d="M30.413 0H21.213V51H30.413V0Z" fill="#FFDA44" />
    <path d="M66 20.849H0V30.049H66V20.849Z" fill="#FFDA44" />
    <path d="M65.5 0.5H0.5V50.5H65.5V0.5Z" stroke="#9F9D9D" />
  </svg>
)
